import LinearProgress from '@mui/material/LinearProgress';
import { Log } from 'oidc-client-ts';
import React, { useEffect } from 'react';
import { AuthProvider, hasAuthParams, useAuth } from 'react-oidc-context';

import { OIDC_CONFIG } from '../../auth/auth';

const DEBUG_AUTH = false;

if (DEBUG_AUTH) {
    const QA_TOKEN_EXPIRATION_TIME = 1200; // seconds
    Log.setLogger(console);
    Log.setLevel(Log.DEBUG);
    OIDC_CONFIG.accessTokenExpiringNotificationTimeInSeconds = QA_TOKEN_EXPIRATION_TIME - 5;
}

interface AuthWallProps {
    children: React.ReactNode;
}

const AuthWall: React.FC<AuthWallProps> = ({ children }) => {
    const { isAuthenticated, isLoading, activeNavigator, signinRedirect } = useAuth();
    // Automatic sign-in, see: https://github.com/authts/react-oidc-context#automatic-sign-in
    useEffect(() => {
        if (!hasAuthParams() && !isAuthenticated && !activeNavigator && !isLoading) {
            signinRedirect();
        }
    }, [isAuthenticated, activeNavigator, isLoading, signinRedirect]);
    return isAuthenticated ? <>{children}</> : <LinearProgress />;
};

interface AuthWrapperProps {
    children: React.ReactNode;
}

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => (
    <AuthProvider {...OIDC_CONFIG}>
        <AuthWall>{children}</AuthWall>
    </AuthProvider>
);
